import React from "react";
import styles from "../../assets/styles/_hairCheck.module.scss";
import p1 from "../../assets/images/check/pinks/prd1.png";
import p2 from "../../assets/images/check/pinks/prd2.png";
import p3 from "../../assets/images/check/pinks/prd3.png";
import p4 from "../../assets/images/check/pinks/prd4.png";
import b1 from "../../assets/images/check/blues/prd1.png";
import b2 from "../../assets/images/check/blues/prd2.png";
import b3 from "../../assets/images/check/blues/prd3.png";
import b4 from "../../assets/images/check/blues/prd4.png";

const Step2 = ({ type, setStep, setCurrentProduct }) => {
  const products = [
    {
      id: 1,
      txt1: "あなたは…",
      title_product: "太髪&健康毛",
      des_product:
        "太髪には、広がりやすい毛先をしっとり<br />まとめるために、水分と豊富な油分が必要です。<br />艶があり、パサつきや引っかかりもない<br />あなたには、過剰なケアは必要ありません。<br />日々のシャンプー・トリートメントで<br />艶と指通りをキープしましょう。",
      imgs: [p2, p1],
      background: "#E8BFFF",
      fontSize: 12,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー ディープモイスト<br />ウォーターコートトリートメント ディープモイスト",
    },
    {
      id: 2,
      txt1: "あなたは…",
      title_product: "太髪&ヘアカラー",
      des_product:
        "太髪には、広がりやすい毛先をしっとりまとめるために、水分と豊富な油分が必要です。ヘアカラーを月1回以上定期的に繰り返しているあなたには、ヘアオイルで髪の毛をコーティングして色素の流出を防ぎ、紫外線や物理的な摩擦から髪を守ってあげることで艶やかな髪色をキープすることがおすすめです。シャンプー・トリートメントをした後にヘアミルクで髪にうるおいを補給し、ドライヤーで半乾きまで乾かしたらパサつきが気になる部分にヘアオイルをつけてコーティングして、再びドライヤーで完全に乾かしましょう。毛先広がらず、しなやかで指通り良く、ヘアカラーも艶やかに見えるまとまり髪になります。",
      imgs: [p2, p1, p3, p4],
      background: "#E8BFFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー ディープモイスト<br />ウォーターコートトリートメント ディープモイスト<br />ウォーターコートヘアミルク ディープモイスト<br />ウォーターコートヘアオイル ディープモイスト",
    },
    {
      id: 3,
      txt1: "あなたは…",
      title_product: "太髪&ブリーチ",
      des_product:
        "太髪には、広がりやすい毛先をしっとりまとめるために、<br />水分と豊富な油分が必要です。ブリーチヘアのあなたには、<br />失ってしまった水分をヘアミルクで補い、ヘアオイルでしっかりとフタをすることがおすすめです。艶と透明感のあるブロンド<br />ヘアやデザインカラーを楽しむことができます。シャンプー・<br />トリートメントをした後にヘアミルクで髪にうるおいを補給し、ドライヤーで半乾きまで乾かしたらヘアオイルをつけてコーティングして、再びドライヤーで完全に乾かしましょう。<br />完全に乾かしたら、パサつきが気になる部分に再度ヘアオイルを少量つけましょう。毛先広がらず、しなやかで指通り良く、<br />ヘアカラーも艶やかに見えるまとまり髪になります。",
      imgs: [p2, p1, p3, p4],
      background: "#E8BFFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー ディープモイスト<br />ウォーターコートトリートメント ディープモイスト<br />ウォーターコートヘアミルク ディープモイスト<br />ウォーターコートヘアオイル ディープモイスト",
    },
    {
      id: 4,
      txt1: "あなたは…",
      title_product: "太髪&パーマ",
      des_product:
        "太髪には、広がりやすい毛先をしっとりまとめるために、<br />水分と豊富な油分が必要です。<br />パーマヘアのあなたには、ヘアミルクの併用が<br />おすすめです。パーマは水分を含むことでカールが<br />出やすくなるので、ドライヤー前にたっぷりと<br />ヘアミルクをパーマ部分に塗布し、必要であれば<br />ドライヤー後にも再度ヘアミルクを塗布すると<br />艶のあるウェーブヘアを楽しむことができます。",
      imgs: [p2, p1, p3],
      background: "#E8BFFF",
      fontSize: 12,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー ディープモイスト<br />ウォーターコートトリートメント ディープモイスト<br />ウォーターコートヘアミルク ディープモイスト",
    },
    {
      id: 5,
      txt1: "あなたは…",
      title_product: "太髪&縮毛矯正",
      des_product:
        "太髪には、広がりやすい毛先をしっとりまとめるために、<br />水分と豊富な油分が必要です。縮毛矯正をされている<br />あなたには、熱処理で失われた髪の水分をヘアミルクで補い、ヘアオイルでコーティングをすることがおすすめです。<br />ドライヤーの熱から髪の毛を守り、縮毛矯正をしたサラサラの手触りが長持ちしやすくなります。<br />シャンプー・トリートメントをした後にヘアミルクで<br />髪にうるおいを補給し、ドライヤーで半乾きまで乾かしたら<br />ヘアオイルをつけてコーティングして、再びドライヤーで完全に乾かしましょう。完全に乾かしたら、パサつきが気になる<br />部分に再度ヘアオイルを少量つけましょう。",
      imgs: [p2, p1, p3, p4],
      background: "#E8BFFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー ディープモイスト<br />ウォーターコートトリートメント ディープモイスト<br />ウォーターコートヘアミルク ディープモイスト<br />ウォーターコートヘアオイル ディープモイスト",
    },
    {
      id: 6,
      txt1: "あなたは…",
      title_product: "太髪&<br />コテ･アイロン",
      des_product: "太髪には、広がりやすい毛先をしっとりまとめるために、水分と<br />豊富な油分が必要です。コテやアイロンを毎日使うあなたには、<br />熱処理で失われた髪の水分をヘアミルクで補い、ヘアオイルで<br />コーティングをすることがおすすめです。ドライヤーの熱から<br />髪の毛を守り、熱を加えることが髪が硬くなってしまう<br />「タンパク変性」を最小限に抑えることができます。シャンプー・<br />トリートメントをした後にヘアミルクで髪にうるおいを補給し、<br />ドライヤーで半乾きまで乾かしたらヘアオイルをつけて<br />コーティングして、再びドライヤーで完全に乾かしましょう。<br />完全に乾かしたら、パサつきが気になる部分に再度ヘアオイルを<br />少量つけましょう。",
      imgs: [p2, p1, p3, p4],
      background: "#E8BFFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー ディープモイスト<br />ウォーターコートトリートメント ディープモイスト<br />ウォーターコートヘアミルク ディープモイスト<br />ウォーターコートヘアオイル ディープモイスト",
    },
    {
      id: 7,
      txt1: "あなたは…",
      title_product: "細髪&健康毛",
      des_product:
        "細髪には、からまりやすい髪をベタっとした<br />仕上がりにならずに指通り良くするために、<br />水分とタンパク質と過剰すぎない油分が必要です。<br />艶があり、パサつきや引っかかりもない<br />あなたには、過剰なケアは必要ありません。<br />日々のシャンプー・トリートメントで<br />艶と指通りをキープしましょう。",
      imgs: [b2, b1],
      background: "#6BDCFF",
      fontSize: 12,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー スリークモイスト<br />ウォーターコートトリートメント スリークモイスト",
    },
    {
      id: 8,
      txt1: "あなたは…",
      title_product: "細髪&ヘアカラー",
      des_product:
        "細髪には、からまりやすい髪をベタっとした仕上がりにならずに指通り良くするために、水分とタンパク質と過剰すぎない<br />油分が必要です。ヘアカラーを月1回以上定期的に繰り返して<br />いるあなたには、ヘアオイルで髪の毛をコーティングして色素の流出を防ぎ、紫外線や物理的な摩擦から髪を守ってあげる<br />ことで艶やかな髪色をキープすることがおすすめです。<br />シャンプー・トリートメントをした後にヘアミルクで髪に<br />うるおいを補給し、ドライヤーで半乾きまで乾かしたら<br />パサつきが気になる部分にヘアオイルをつけてコーティング<br />して、再びドライヤーで完全に乾かしましょう。からまらず、<br />サラサラと指通り良く、まとまる仕上がりになります。",
      imgs: [b2, b1, b3, b4],
      background: "#6BDCFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー スリークモイスト<br />ウォーターコートトリートメント スリークモイスト<br />ウォーターコートヘアミルク スリークモイスト<br />ウォーターコートヘアオイル スリークモイスト",
    },
    {
      id: 9,
      txt1: "あなたは…",
      title_product: "細髪&ブリーチ",
      des_product:
        "細髪には、からまりやすい髪をベタっとした仕上がりにならずに<br />指通り良くするために、水分とタンパク質と過剰すぎない<br />油分が必要です。ブリーチヘアのあなたには、失ってしまった<br />水分をヘアミルクで補い、ヘアオイルでしっかりとフタをする<br />ことがおすすめです。艶と透明感のあるブロンドヘアやデザイン<br />カラーを楽しむことができます。シャンプー・トリートメントを<br />した後にヘアミルクで髪にうるおいを補給し、ドライヤーで<br />半乾きまで乾かしたらヘアオイルをつけてコーティングして、<br />再びドライヤーで完全に乾かしましょう。完全に乾かしたら、<br />パサつきが気になる部分に再度ヘアオイルを少量つけましょう。<br />からまらず、サラサラと指通り良く、ヘアカラーも艶やかに見える<br />まとまり髪になります。",
      imgs: [b2, b1, b3, b4],
      background: "#6BDCFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー スリークモイスト<br />ウォーターコートトリートメント スリークモイスト<br />ウォーターコートヘアミルク スリークモイスト<br />ウォーターコートヘアオイル スリークモイスト"
    },
    {
      id: 10,
      txt1: "あなたは…",
      title_product: "細髪&パーマ",
      des_product:
        "細髪には、からまりやすい髪をベタっとした仕上がりに<br />ならずに指通り良くするために、水分とタンパク質と<br />過剰すぎない油分が必要です。パーマヘアのあなたには、ヘアミルクの併用がおすすめです。パーマは水分を含む<br />ことでカールが出やすくなるので、ドライヤー前に<br />たっぷりとヘアミルクをパーマ部分に塗布し、必要で<br />あればドライヤー後にも再度ヘアミルクを塗布すると<br />艶のあるウェーブヘアを楽しむことができます。",
      imgs: [b2, b1, b3],
      background: "#6BDCFF",
      fontSize: 12,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー スリークモイスト<br />ウォーターコートトリートメント スリークモイスト<br />ウォーターコートヘアミルク スリークモイスト",
    },
    {
      id: 11,
      txt1: "あなたは…",
      title_product: "細髪&縮毛矯正",
      des_product:
        "細髪には、からまりやすい髪をベタっとした仕上がりにならずに指通り良くするために、水分とタンパク質と過剰すぎない<br />油分が必要です。縮毛矯正をされているあなたには、熱処理で<br />失われた髪の水分をヘアミルクで補い、ヘアオイルで<br />コーティングをすることがおすすめです。ドライヤーの熱から<br />髪の毛を守り、縮毛矯正をしたサラサラの手触りが長持ち<br />しやすくなります。シャンプー・トリートメントをした後にヘアミルクで髪にうるおいを補給し、ドライヤーで半乾きまで乾かしたらヘアオイルをつけてコーティングして、再びドライヤーで完全に乾かしましょう。完全に乾かしたら、パサつきが<br />気になる部分に再度ヘアオイルを少量つけましょう。",
      imgs: [b2, b1, b3, b4],
      background: "#6BDCFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー スリークモイスト<br />ウォーターコートトリートメント スリークモイスト<br />ウォーターコートヘアミルク スリークモイスト<br />ウォーターコートヘアオイル スリークモイスト",
    },
    {
      id: 12,
      txt1: "あなたは…",
      title_product: "細髪&<br />コテ･アイロン",
      des_product:
        "細髪には、からまりやすい髪をベタっとした仕上がりにならずに<br />指通り良くするために、水分とタンパク質と過剰すぎない油分が<br />必要です。コテやアイロンを毎日使うあなたには、熱処理で失わ<br />れた髪の水分をヘアミルクで補い、ヘアオイルでコーティングを<br />することがおすすめです。ドライヤーの熱から髪の毛を守り、熱を加えることが髪が硬くなってしまう「タンパク変性」を最小限に<br />抑えることができます。シャンプー・トリートメントをした後に<br />ヘアミルクで髪にうるおいを補給し、ドライヤーで半乾きまで<br />乾かしたらヘアオイルをつけてコーティングして、再びドライヤーで完全に乾かしましょう。完全に乾かしたら、パサつきが気になる部分に再度ヘアオイルを少量つけましょう。",
      imgs: [b2, b1, b3, b4],
      background: "#6BDCFF",
      fontSize: 11,
      featured_products:
        "【おすすめ商品】<br />ウォーターコートシャンプー スリークモイスト<br />ウォーターコートトリートメント スリークモイスト<br />ウォーターコートヘアミルク スリークモイスト<br />ウォーターコートヘアオイル スリークモイスト"
    },
  ];

  const data = [
    {
      id: 1,
      label_btn: "特に何もしていない",
      fontSize: 22,
      background: "linear-gradient(0deg, rgb(228 169 213 / 50%) 0%, rgb(87 141 245 / 29%) 50%)",
      typePinkProductId: 1,
      typeBlueProductId: 7,
    },
    {
      id: 2,
      label_btn: "コテ･アイロンを毎日",
      fontSize: 22,
      background: "linear-gradient(0deg, rgb(228 169 213 / 50%) 0%, rgb(87 141 245 / 29%) 50%)",
      typePinkProductId: 6,
      typeBlueProductId: 12,
    },
    {
      id: 3,
      label_btn: "ヘアカラーを月1回以上",
      fontSize: 20,
      background: "linear-gradient(0deg, rgb(228 169 213 / 50%) 0%, rgb(87 141 245 / 29%) 50%)",
      typePinkProductId: 2,
      typeBlueProductId: 8,
    },
    {
      id: 4,
      label_btn: "ブリーチをしている",
      fontSize: 22,
      background: "linear-gradient(0deg, rgb(228 169 213 / 50%) 0%, rgb(87 141 245 / 29%) 50%)",
      typePinkProductId: 3,
      typeBlueProductId: 9,
    },
    {
      id: 5,
      label_btn: "パーマをかけている",
      fontSize: 22,
      background: "linear-gradient(0deg, rgb(228 169 213 / 50%) 0%, rgb(87 141 245 / 29%) 50%)",
      typePinkProductId: 4,
      typeBlueProductId: 10,
    },
    {
      id: 6,
      label_btn: "縮毛矯正をしている",
      fontSize: 22,
      background: "linear-gradient(0deg, rgb(228 169 213 / 50%) 0%, rgb(87 141 245 / 29%) 50%)",
      typePinkProductId: 5,
      typeBlueProductId: 11,
    },
  ];
  const handleClickButton = (item) => {
    if (type === "pink") {
      setCurrentProduct(products.find((product) => product.id === item.typePinkProductId));
    }
    if (type === "blue") {
      setCurrentProduct(products.find((product) => product.id === item.typeBlueProductId));
    }
    setStep(3);
  };
  return (
    <div className={styles.step2}>
      <div className={styles.txt1}>Q2.</div>
      <div className={styles.title}>
        最近の <br />
        ヘアスタイリングは？
      </div>
      <hr className={styles.line} />
      {data.map((item) => (
        <div
          className={styles.btn}
          onClick={() => handleClickButton(item)}
          style={{ background: item.background, fontSize: item.fontSize }}
        >
          {item.label_btn}
        </div>
      ))}
    </div>
  );
};

export default Step2;
